import React, { useState, useEffect } from 'react';
import { Container, Box, CircularProgress } from '@mui/material';
import { useParams, useNavigate } from "react-router-dom";
import supabase from '../../supabaseClient';
import WorkerDeviceAttendanceScanner from './WorkerDeviceAttendanceScanner';

const WorkerDeviceDetails = () => {
    const navigate = useNavigate();
    const { id } = useParams();
    const [name, setName] = useState('');
    const [loading, setLoading] = useState(true);
    const [idConfig, setIdConfiguration] = useState('');

    useEffect(() => {
        const checkSession = async () => {
            const { data } = await supabase.auth.getSession();
            if (data?.session) {
                fetchData(data.session.user.id);
            } else {
                setLoading(false);
            }
        };
        checkSession();
    }, [id]);

    const fetchData = async (userId) => {
        const { data: profileData } = await supabase
            .from('profiles')
            .select('id_configuration')
            .eq('id', userId)
            .single();

        if (profileData) {
            setIdConfiguration(profileData.id_configuration);
            fetchEmployee(profileData.id_configuration);
        } else {
            setLoading(false);
        }
    };

    const fetchEmployee = async (configId) => {
        setLoading(true);
        const { data, error } = await supabase
            .from('devices')
            .select('name')
            .eq('id', id)
            .eq('id_configuration', configId)
            .single();

        if (error) {
            console.error("Błąd pobierania urządzenia:", error);
            navigate('/workerDevices'); // Poprawiono przekierowanie na listę maszyn
        } else if (data) {
            setName(data.name || '');
        }
        setLoading(false);
    };

    if (loading) {
        return (
            <Box display="flex" justifyContent="center" alignItems="center" minHeight="50vh">
                <CircularProgress />
            </Box>
        );
    }

    return (
        <Container maxWidth="xl" sx={{ mt: '40px', pb: '40px' }}>
            <WorkerDeviceAttendanceScanner />
        </Container>
    );
};

export default WorkerDeviceDetails;